import { Injectable, ErrorHandler } from '@angular/core';
import { SentryService } from './sentry.service';


@Injectable()
export class CustomErrorHandler implements ErrorHandler {

    constructor(
        public sentry: SentryService
    ) {}

    /**
     * Quando ocorre um erro, o erro é recuperado.
     * @param error Objeto de erro.
     */
    public handleError(error: Error) {
        this.sentry.send(error);
        console.error(error);
    }

}